<script setup lang="ts">
import { SlimBanner } from '~/types/Content'

const props = defineProps<SlimBanner>()

const currentComponent = computed(() => {
  switch (props.variant) {
    case 'content':
      return resolveComponent('ContentBanner')
    case 'collection':
      return resolveComponent('CollectionBanner')
    default:
      return resolveComponent('Undefined')
  }
})
</script>

<template>
  <component :is="currentComponent" v-bind="{ ...props, ...$attrs }" />
</template>
